'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import * as Styles from './styles';
import { useAccordionContext } from '.';
export const AccordionSectionContext = createContext({
    disabled: false,
    id: 0,
});
export const useAccordionSectionContext = () => useContext(AccordionSectionContext);
export const isAccordionSection = (element) => {
    return (typeof element !== 'string' && typeof element !== 'number' && element.type === AccordionSection);
};
export const AccordionSection = ({ id, children, defaultIsActive = false, disabled = false, }) => {
    const { multiOpen, variant, showBorder, activeSectionIds, setActiveSectionIds } = useAccordionContext();
    const handleChange = (open) => {
        if (multiOpen) {
            if (open === true && !activeSectionIds.includes(id)) {
                setActiveSectionIds(s => [...s, id]);
            }
            else if (open === false && activeSectionIds.includes(id)) {
                setActiveSectionIds(s => s.filter(sectionId => sectionId !== id));
            }
        }
        else {
            if (open === true && !activeSectionIds.includes(id)) {
                setActiveSectionIds([id]);
            }
            else if (open === false && activeSectionIds.includes(id)) {
                setActiveSectionIds([]);
            }
        }
    };
    return (_jsx(Styles.SectionContainer, { "$variant": variant, "$showBorder": showBorder, defaultIsExpanded: defaultIsActive, isExpanded: activeSectionIds.includes(id), onChange: handleChange, children: _jsx(AccordionSectionContext.Provider, { value: {
                id,
                disabled,
            }, children: children }) }));
};
//# sourceMappingURL=Section.js.map